var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnfilledstar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#134563;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Star",
    transform: "translate(126.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-79.9-170.1c-0.2,0-0.5-0.1-0.7-0.2l-13.4-9.7l-13.4,9.7c-0.4,0.3-1,0.3-1.4,0     c-0.4-0.3-0.6-0.9-0.4-1.3l5.1-15.7l-13.4-9.7c-0.4-0.3-0.6-0.9-0.4-1.3c0.2-0.5,0.6-0.8,1.1-0.8h16.5l5.1-15.7     c0.2-0.5,0.6-0.8,1.1-0.8c0.5,0,1,0.3,1.1,0.8l5.1,15.7h16.5c0.5,0,1,0.3,1.1,0.8c0.2,0.5,0,1-0.4,1.3l-13.4,9.7l5.1,15.7     c0.2,0.5,0,1-0.4,1.3C-79.4-170.2-79.7-170.1-79.9-170.1L-79.9-170.1z M-94-182.8c0.2,0,0.5,0.1,0.7,0.2l11.1,8l-4.2-13     c-0.2-0.5,0-1,0.4-1.3l11.1-8h-13.7c-0.5,0-1-0.3-1.1-0.8l-4.2-13l-4.2,13c-0.2,0.5-0.6,0.8-1.1,0.8H-113l11.1,8     c0.4,0.3,0.6,0.9,0.4,1.3l-4.2,13l11.1-8C-94.5-182.7-94.2-182.8-94-182.8L-94-182.8z",
    id: "Fill-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledstar);
export default __webpack_public_path__ + "static/media/unfilledstar.f8eedfed5ea4a486d923dcce9fb98e03.svg";
export { ForwardRef as ReactComponent };